import styled from 'styled-components';

export const ProfileSection = styled.div`
  
background: #FFFFFF 0% 0% no-repeat padding-box;
box-shadow: 0px 20px 20px #0000001A;
border-radius: 10px;
padding:10px;
    @media screen and (max-width: 767px){
        max-width:inherit;
    }
`;
export const ProfileImage = styled.div`
    box-shadow: 3px 10px 20px #00000033;
    border-radius: 8px;
 
     img{
        width: 100%;
        border-radius: 8px;
        
        // max-width: 262px;
        // height: auto; 
     }
`;
export const ProfileName = styled.h3`
    color: #000000;
    font-family: "Jost", sans-serif;
    font-size:20px;
    font-weight: bold;
    line-height: 27px;
    margin-bottom: 10px;
   
`;
export const ProfileReview = styled.span`
    color: #33A7AE;
    font-family: "Jost", sans-serif;
    font-size:14px;
    font-weight: 400;
    line-height: 21px;
    margin-bottom: 5px;
    display:block;
`;


export const ProfileDetails = styled.div`
    text-align: center;
    margin-top: 20px;
`;
